import { SERVER_URL } from "../constants/Api";
import client from "./httpClient";

const baseUrl = `${SERVER_URL}/api/2/branding/branding.json`;

export const fetchBranding = async () => {
  return await client
    .get(baseUrl)
    .json();
};
